import {createMuiTheme} from 'material-ui/styles';
import teal from 'material-ui/colors/teal';
import pink from 'material-ui/colors/pink';
import red from 'material-ui/colors/red';


export const theme = createMuiTheme({
    palette: {
        primary: teal,
        secondary: pink,
        error: red
    }
});


// WEBPACK FOOTER //
// ./src/assets/theme.js